import { useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import PATHS from '../../../../routes/routes.const';
import { useApplicationContext } from '../../../context/ApplicationContext/ApplicationContext';
import { useNetworkContext } from '../../../offline/contexts/network/network.context';
import { OfflineStatus } from '../../../offline/domain/offlineOrder/offlineOrder.types';
import useOfflineOrdersSyncingHandler from '../../../offline/hooks/useOfflineOrdersSyncingHandler/useOfflineOrdersSyncingHandler';
import { ValidateSyncingOrdersAndReturnResultOutput } from '../../../offline/stores/offlineOrders/types/offlineOrders.actions.types';
import { Role } from '../../actions/types/actions.types';
import { Order, StatusType } from '../../order.types';
import { getOrderView } from '../../ordersView.utils';

interface UseHandleOfflineOrderSyncingToOrderProps {
  reloadCurrentOrder: () => void;
  order?: Order<boolean>;
}

export const useHandleOfflineOrderSyncingToOrder = ({
  order,
  reloadCurrentOrder,
}: UseHandleOfflineOrderSyncingToOrderProps) => {
  const history = useHistory();
  const { isForcingOfflineMode } = useNetworkContext();

  const { userRole } = useApplicationContext();

  const onOfflineOrderChangeSyncStatus = async (
    result: ValidateSyncingOrdersAndReturnResultOutput,
  ) => {
    if (!order) {
      return;
    }

    const newStatus = result.unsyncedOfflineOrders.length
      ? OfflineStatus.ERROR_SYNCING
      : StatusType.DRAFT;

    if (newStatus === OfflineStatus.ERROR_SYNCING) {
      reloadCurrentOrder();
      return;
    }

    if (newStatus === StatusType.DRAFT && isForcingOfflineMode) {
      history.replace(PATHS.offline.orders.path);
    } else {
      const offlineOrder = result.partiallySyncedOfflineOrders[0] || result.syncedOfflineOrders[0];

      const orderView = getOrderView({
        role: userRole as Role,
        orderStatus: newStatus,
      });

      history.replace(
        `${PATHS.main.orders.path}/${offlineOrder.metadata?.onlineMetadata?.onlineOrderId}/${orderView}`,
      );
    }
  };
  const { handleWithOfflineOrdersSyncing } = useOfflineOrdersSyncingHandler({
    onAnyChange: onOfflineOrderChangeSyncStatus,
  });

  useEffect(() => {
    if (!order?.id || order.status !== OfflineStatus.SYNCING) {
      return;
    }

    handleWithOfflineOrdersSyncing([order.id]);
  }, [order?.id]);
};
